import MainButton from "../../../components/button/mainButton";
import HeaderBar from "../../../components/header/headerBar";
import { Textarea } from "../../../components/textfield";
import { useEffect, useState } from "react";
import {
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Typography,
  Input,
  Space,
  Table,
  Checkbox,
  message,
  Button,
} from "antd";
import axios from "axios";
import { useParams } from "react-router-dom";
import { numberWithCommas } from "../../../helpers/functions.js";
import moment from "moment";
import { useHistory } from "react-router";

interface ParamsType {
  id: string;
}

const Conclusion = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [agencyOPD, setAgencyOPD] = useState<string>("");
  const [agencySO, setAgencySO] = useState<any>([]);
  const { Option } = Select;
  const { id } = useParams<ParamsType>();
  const CheckboxGroup = Checkbox.Group;
  const [customerTypeCode, setcustomerTypeCode] = useState<string>("");

  const [textBanner2, setTextBanner2] = useState<any>([]);
  const [description, setDescription] = useState<string>("");

  const [typeSaleCheck, setTypeSaleCheck] = useState<string>("");

  const [summary, setSummary] = useState<any>([]);
  const [optHowDidYou, setOptHowDidYou] = useState<any>([]);
  const [OtherDer, setOtherDer] = useState<any>([]);

  const history = useHistory();

  const { Text } = Typography;

  let [formCo_User] = Form.useForm();

  const [other, setOther] = useState<string>("");
  const [otherHearDer, setOtherHearDer] = useState<string>("");

  const [dataBuySO, setDataBuySO] = useState<any>([]);

  const [dataHead, setDataHead] = useState<any>([]);
  const [dataCart, setDataCart] = useState<any>([]);
  const [sum, setSum] = useState<number>(0);
  const [sumDiscount, setSumDisCount] = useState<number>(0);
  const [hear, sethear] = useState<string>("");
  const [hearSelect, setHearSelect] = useState<any>([]);

  const [idSo, setIdSo] = useState<string>("");
  const columns = [
    {
      key: 1,
      title: "รหัส/Code",
      dataIndex: "code",
      align: "center" as const,
    },
    {
      key: 2,
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as const,
    },
    {
      key: 3,
      title: "ราคา/หน่วย/Price/Unit",
      dataIndex: "price",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      key: 4,
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as const,
      width: "10%",
    },
    {
      title: "รวม/Total",
      dataIndex: "total",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: number) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      title: "จำนวน/คอร์ส/Number/Course",
      dataIndex: "number",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text)}</>;
      },
    },
    {
      key: 5,
      title: "คอมมิชชั่น/Commission",
      align: "center" as const,
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "isCommissionSales",
          width: "6%",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "isCommissionDoctor",
          width: "5%",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
      ],
    },
    {
      key: 6,
      title: "ฟรี/Free",
      dataIndex: "free",
      align: "center" as const,
      width: "28%",
      render: (text: any, record: any, index: number) => {
        return record?.free?.productFree !== undefined &&
          record?.free?.productFree !== null
          ? record?.free?.productFree?.name
          : "Not Select";
      },
    },
    {
      key: 6,
      title: "รหัสฟรี/Code Free",
      dataIndex: "codefree",
      align: "center" as const,
      width: "28%",
      render: (text: any, record: any, index: number) => {
        return record?.free?.codefree;
        // console.log("record", );
      },
    },
    {
      key: 7,
      title: "ส่วนลดพิเศษ/Special Discount",
      dataIndex: "specialPrice",
      width: "10%",
      align: "center" as const,
      render(text: any, record: any) {
        return numberWithCommas(text, 2);
      },
    },
    {
      key: 8,
      title: "ราคาพิเศษ/Special Price",
      dataIndex: "specialDiscount",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: number) => {
        return numberWithCommas(text, 2);
      },
    },
    {
      key: 9,
      title: "ราคารวม/Total Price",
      dataIndex: "totalPrice",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: number) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },

    {
      key: 10,
      title: "ความเห็น/Remark",
      dataIndex: "remark",
      align: "center" as const,
      // render: (text: any, record: any, index: number) => {
      //   // console.log("record =>remark", record);
      //   // return <Row style={{ width: "150px" }}>{text}</Row>;
      // },
    },
  ];
  const columnspromo = [
    {
      key: 1,
      title: "รหัส/Code",
      dataIndex: "code",
      align: "center" as const,
      width: "200px",
      // render: (text: any, record: any) => {
      //   return <>{text}</>;
      // },
    },
    {
      key: 2,
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as const,
      width: "450px",
    },
    {
      key: 3,
      title: "ราคา/หน่วย/Price/Unit",
      dataIndex: "price",
      align: "center" as const,
      width: "200px",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      key: 4,
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as const,
      width: "180px",
      // render: (text: any, record: any, index: number) => (
      //   <div style={{ display: "flex", justifyContent: "center" }}>{text}</div>
      // ),
    },
    // {
    //   title: "รวม/Total",
    //   dataIndex: "total",
    //   align: "center" as const,
    //   width: "10%",
    //   render: (text: any, record: any, index: number) => {
    //     return <>{numberWithCommas(text, 2)}</>;
    //   },
    // },

    {
      key: 5,
      title: "คอมมิชชั่น/Commission",
      align: "center" as const,
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "isCommissionSales",
          width: "150px",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "isCommissionDoctor",
          width: "150px",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
      ],
    },

    // {
    //   key: 9,
    //   title: "ราคารวม/Total Price",
    //   dataIndex: "totalPrice",
    //   align: "center" as const,
    //   width: "10%",
    //   render: (text: any, record: any, index: number) => {
    //     return <>{numberWithCommas(text, 2)}</>;
    //   },
    // },

    {
      key: 10,
      title: "ความเห็น/Remark",
      dataIndex: "remark",
      align: "center" as const,
      width: "15%",
      // render: (text: any, record: any, index: number) => {
      //   // console.log("record =>remark", record);
      //   // return <Row style={{ width: "150px" }}>{text}</Row>;
      // },
    },
  ];
  const dateFormat = "DD-MM-YYYY";
  const getAllDatas = (value: any, typecode?: string) => {
    setTypeSaleCheck(value?.purchaseType);
    if (value?.purchaseType === "normal") {
      // console.log("data normal", value?.items);
      const newdatacart = value.items.map((data: any) => ({
        ...data,
        total:
          typecode === "Local"
            ? parseInt(data?.price) * parseInt(data?.quantity)
            : parseInt(data?.priceAgency) * parseInt(data?.quantity),
        number: parseFloat(data?.number) * parseFloat(data?.quantity),
      }));

      setDataCart(newdatacart);
    } else if (value?.purchaseType === "promotion") {
      // setDataCart()
      // console.log("data promotion", value?.items);
      setDataCart(value?.items);
    }
  };

  const getUserAgencySo = async (search?: any) => {
    await axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      // console.log("res=>>>>>>>", res?.data?.data);
      let data = res?.data?.data;
      const code = [];
      for (let i = 0; i < data.length; i++) {
        code.push(
          <Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.displayName}
          </Option>
        );
      }
      setAgencySO(code);
    });
  };

  const getBranch = (id: any) => {
    axios.get(`/branches/${id}`).then((res) => {
      let xBranch = res?.data?.data?.name;
      formCo_User.setFieldsValue({
        branch: xBranch,
      });
    });
  };

  const getUser = async (id: any, type: any) => {
    await axios.get(`/member-opd/${id}`).then((res) => {
      let xUser = res?.data;
      if (type === "Couserat1") {
        formCo_User.setFieldsValue({
          Couser1: xUser.firstName + " " + xUser.lastName,
        });
      } else if (type === "Couserat2") {
        formCo_User.setFieldsValue({
          Couser2: xUser.firstName + " " + xUser.lastName,
        });
      } else if (type === "Couserat3") {
        formCo_User.setFieldsValue({
          Couser3: xUser.firstName + " " + xUser.lastName,
        });
      } else if (type === "Couserat4") {
        formCo_User.setFieldsValue({
          Couser4: xUser.firstName + " " + xUser.lastName,
        });
      }
    });
  };
  const getAgencySo = async () => {
    let xdata = await axios.get(`/member-opd/${id}`);

    axios.get(`/agencies/members/${xdata?.data?.agencyMember}`).then((res) => {
      const xAgency = res?.data?.name;

      // console.log("xAgency", xAgency);

      setAgencyOPD(xAgency);
    });
  };
  const getConsult = async (id: any, type: any) => {
    axios.get(`/users/${id}`).then((res) => {
      let xConsult = res?.data;
      if (type === "Consult1") {
        formCo_User.setFieldsValue({
          Consult1: xConsult.firstName + " " + xConsult.lastName,
        });
      } else if (type === "Consult2") {
        formCo_User.setFieldsValue({
          Consult2: xConsult.firstName + " " + xConsult.lastName,
        });
      }
    });
  };

  const getDatasHead = async () => {
    axios.get(`/so/get-cart?memberId=${id}`).then((res) => {
      let xdata = res.data;
      console.log("xdata datahead", xdata);

      setIdSo(xdata?._id);
      setDataHead({
        ...dataHead,
        customer: xdata?.customer,
        customerCode: xdata?.customerCode,
        cn: xdata?.customerCode,
        ref: xdata?.code,
      });

      formCo_User.setFieldsValue({
        date: moment(xdata?.date),
        doctor: xdata?.doctor,
        purchaseType: xdata?.purchaseType,
        priceType: xdata?.priceType,
      });
      getBranch(xdata?.branch);

      setOther(xdata?.purchaseType);
      setSum(xdata?.balanceAfterAllDiscount);
      setSumDisCount(xdata?.totalDiscountAmount);
      setDescription(xdata?.note);

      setTypePrice(xdata);

      setTextBanner2(xdata?.fullDiscount);
      xdata.coMembers.map((data: any, index: number) =>
        getUser(data, `Couserat${index + 1}`)
      );
      xdata.consults.map((data: any, index: number) =>
        getConsult(data, `Consult${index + 1}`)
      );
      getDoctor(xdata.doctor);
    });
  };
  const getDoctor = async (id: any) => {
    axios.get(`/users/${id}`).then((res) => {
      let xDoctor = res?.data;
      formCo_User.setFieldsValue({
        Doctor: xDoctor.firstName + "  " + xDoctor.lastName,
      });
    });
  };

  // const getOptionFree = async () => {
  //   await axios.get(`/product-frees`).then((res) => {
  //     // console.log("res free", res?.data?.data);
  //     let optFrees = res?.data?.data;
  //     let optFreesNew = [...optFrees];
  //     let xoptfrees = { code: "Discount", id: "Discount", name: "Discount" };
  //     optFreesNew.push(xoptfrees);
  //     // console.log("optFreesNew", optFreesNew);

  //     const optFree = [];
  //     for (let i = 0; i < optFreesNew?.length; i++) {
  //       optFree.push(
  //         <Select.Option value={optFreesNew[i]?.code} key={optFreesNew[i]?._id}>
  //           {optFreesNew[i]?.name}
  //         </Select.Option>
  //       );
  //     }
  //     setOptFree(optFree);
  //   });
  // };

  const getAPIs = async () => {
    getHowDidYou();
    getDatasHead();
    getAgencySo();
    // getUser();
  };

  // useEffect(() => {
  //   console.log("datacart", dataCart);
  // }, [dataCart]);

  useEffect(() => {
    getAPIs();
    // setOther("Normal");
    // console.log("id=>>", id);
    // purchaseChecked();
  }, []);
  useEffect(() => {
    // console.log("dataBuySO", dataBuySO);
  }, [dataBuySO]);

  const getHowDidYou = async () => {
    await axios.get(`/hear-about-dermasters`).then((res) => {
      // let xHear = res?.data?.data;
      // console.log("xHear", xHear);
      // setOptHowDidYou(xHear);
      //  --,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
      let data = res?.data?.data;
      let code = [];
      let check = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        check.push({ label: other?.name, value: other?._id });
        setOtherDer(check);
      }
      setOptHowDidYou(code);
    });
  };

  const onChangeHearDer = (value: any) => {
    // console.log("hearder", value);
    // console.log("type", type);
    // value.push(type);
    // if (type === "howdid") {
    setHearSelect(value);
    // } else if (type === "other") {
    // }
    // let hear = formCo_User.getFieldsValue(["hearAboutDermasters"]);

    // console.log("hear", hear);

    // setHearSelect(hear);

    // hearSelect.push(value);

    // const hearDer = value.join(",");
    // console.log("xSelect Hear Der", hearDer);
  };
  const onChangeHearDerOther = (value: any) => {
    // console.log("hearderOther", value);
    // console.log("otherHearDer", otherHearDer);

    // const xhear = [...hear];

    // const xhear = hear.map((data: any) => ({));

    // console.log("xhear", xhear);

    sethear(value.join());
  };
  const onchangeSo = (e: any) => {
    setSummary(e);
  };
  useEffect(() => {
    // console.log("summary useEffect", summary);
  }, [summary]);

  const onsubmit = () => {
    if (summary.length === 0) {
      message.error("กรุณาเลือก AGENCY SO !");
      return;
    }

    // if (hearSelect.join() === "") {
    //   message.error("กรุณาเลือก How did you hear about Dermaster? !");
    //   return;
    // }

    if (otherHearDer === "") {
      // message.error("กรุณากรอก หมายเหตุ อื่นๆ !");
      // return;
    }
    // console.log("summary", summary);

    // console.log("OtherHearDer", otherHearDer);

    // console.log("hearDer", hear);
    // console.log("hearSelect", hearSelect.join());
    let xhear = {};
    if (hear !== "") {
      xhear = {
        _id: hear,
        other: otherHearDer,
      };
    }
    // console.log("xhear", xhear);

    const cc = hearSelect.map((data: any) => ({
      _id: data,
    }));

    // console.log("cc", cc);
    if (hear !== "") {
      cc.push(xhear);
    }

    const obj = Object.assign({}, cc);

    // console.log("obj", obj);
    try {
      axios
        .patch(`/so/popup-complete?soId=${idSo}`, {
          agencySO: summary,
          hearAboutDermasters: [obj],
        })
        .then((res) => {
          message.success(`บันทีกสำเร็จ / Save Success`);
          history.push(`/opd/so/${id}`);
        });
    } catch (error) {
      message.error("ข้อมูลผิดพลาด");
      return;
    }

    // if (hear.length > 0) {
    //   try {
    //     axios
    //       .patch(`/member-opd/${id}`, {
    //         agencySO: summary,
    //         hearAboutDermasters: [obj],
    //       })
    //       .then((res) => {
    //
    //       });
    //   } catch (error) {
    //
    //   }
    // }
  };
  const setTypePrice = (xdata: any) => {
    console.log("customerTypeCode", xdata?.customerTypeCode);

    const localPrice = ["CNT", "CNM", "CNS"];
    const agencyPrice = ["CNA", "CNC", "CNE", "CNF"];

    let typecode = "";

    if (localPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Local";
    } else if (agencyPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Agency";
    }

    getAllDatas(xdata, typecode);
  };
  return (
    <div>
      <Form form={formCo_User} onFinish={onsubmit}>
        <HeaderBar title="สรุปรายการที่ซื้อ / Purchase Summary " btnBack />
        <div style={{ margin: "10px 30px" }}>
          <Modal
            visible={isOpen}
            onCancel={() => setIsOpen(false)}
            footer={false}
            centered
            width={"800px"}
          >
            <Row justify="center" className="custom-card">
              <h6>
                ทำการสั่งซื้อเรียบร้อยแล้ว กรุณาเลือก Agency/ Your order has
                been completed. Please select an Agency.
              </h6>
              <Col span={18} style={{ marginTop: "20px" }}>
                <p>AGENCY OPD</p>
                <Input value={agencyOPD} disabled></Input>
              </Col>
              <Col span={18} style={{ marginTop: "20px" }}>
                <p>AGENCY SO</p>
                <Form.Item name="agencySo">
                  <Select
                    style={{ width: "100%" }}
                    onChange={(e: any) => onchangeSo(e)}
                  >
                    {agencySO}
                  </Select>
                </Form.Item>
              </Col>
              <Col style={{ marginTop: "30px" }}>
                <h6>
                  How did you hear about Dermaster? (รู้จัก Dermaster
                  จากที่ไหน?)
                </h6>
              </Col>

              <Row justify="space-between" style={{ marginTop: "1.5rem" }}>
                <Form.Item name="hearAboutDermasters">
                  <CheckboxGroup
                    className="CheckBox-Group"
                    options={optHowDidYou}
                    // disabled={editValue}
                    onChange={(e: any) => onChangeHearDer(e)}
                  />
                </Form.Item>

                <Col span={24}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "80px",
                    }}
                  >
                    <Form.Item name="checkDer">
                      <CheckboxGroup
                        options={OtherDer}
                        onChange={(e: any) => {
                          onChangeHearDerOther(e);

                          formCo_User.setFieldsValue({ otherDer: "" });
                        }}
                      />
                    </Form.Item>
                    <Form.Item name="otherDer">
                      <Input
                        // disabled={
                        //   editValue ? true : other?.otherDer ? false : true
                        // }
                        onChange={(e) => {
                          setOtherHearDer(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </Row>
            <Row justify="center" style={{ marginTop: "30px" }}>
              <Button
                htmlType="submit"
                onClick={onsubmit}
                style={{
                  width: "50%",
                  height: 50,
                  background: "#4D7E7F",
                  borderRadius: 4,
                  color: "white",
                }}
              >
                บันทึกข้อมูล/Submit
              </Button>
            </Row>
          </Modal>
          <div className="card-view-custom">
            <Row
              justify="space-around"
              className="custom-card"
              gutter={[16, 16]}
            >
              {/* {console.log("dataHead=>>>>", dataHead)} */}
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ชื่อลูกค้า/Customer Name</p>
                <Input value={dataHead?.customer} disabled />
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>รหัสลูกค้า/CN</p>
                <Input value={dataHead?.customerCode} disabled />
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>สาขา/Branch </p>
                <Form.Item name="branch">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>วันที่/Date</p>
                <Form.Item name="date">
                  <DatePicker
                    format={dateFormat}
                    style={{ width: "100%" }}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              justify="space-around"
              className="custom-card"
              gutter={[16, 16]}
              style={{ marginTop: "20px" }}
            >
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 1/ Co - User No.1</p>
                <Form.Item name="Couser1">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 2/ Co - User No.2</p>

                <Form.Item name="Couser2">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 3/ Co - User No.3</p>

                <Form.Item name="Couser3">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 4/ Co - User No.4</p>

                <Form.Item name="Couser4">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>

            <Row
              justify="space-around"
              className="custom-card"
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
            >
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>ผู้ดูแล 1/Consult 1</p>
                <Form.Item name="Consult1">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>ผู้ดูแล 2/Consult 2</p>
                <Form.Item name="Consult2">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>แพทย์/Doctor</p>
                <Form.Item name="Doctor">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col
                xs={24}
                sm={4}
                md={6}
                lg={6}
                style={{ marginTop: "40px" }}
              ></Col>
            </Row>
          </div>

          <h4 className="mt-40">รายการที่ซื้อ/Purchase Item</h4>
          <Table
            columns={typeSaleCheck === "normal" ? columns : columnspromo}
            dataSource={dataCart}
            bordered
            scroll={{ x: "max-content" }}
            rowKey="_id"
          />
          <div
            className="row space-between mt-40"
            style={{ padding: "0px 10px" }}
          >
            <div className="col-6">
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 0px",
                    }}
                  >
                    <Textarea readOnly value={description} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <br />
                  </td>
                </tr>
              </table>
            </div>
            <div className="col-6">
              {other === "normal" && (
                <h5 style={{ padding: "0px 20px", fontSize: "14px" }}>
                  ส่วนลดทั้งรายการ/Full Discount
                </h5>
              )}

              {other === "normal" && (
                <div style={{ padding: "0px 20px" }}>
                  <table width="100%" style={{ fontSize: "14px" }}>
                    <tr
                      style={{
                        backgroundColor: "#fff",
                        height: "50px",
                      }}
                    >
                      <td
                        style={{
                          borderRight: "1px solid #aaa",
                          padding: "0px 10px",
                          width: "50%",
                        }}
                        // onClick={() => {
                        //   setIsGiftVoucher(true);
                        // }}
                      >
                        <b>{textBanner2?.giftVoucherGC?.code}</b>
                      </td>
                      <td
                        align="right"
                        style={{
                          borderLeft: "1px solid #aaa",
                          padding: "0px 10px",
                          width: "50%",
                        }}
                      >
                        <b>{numberWithCommas(textBanner2?.price, 2)}</b>
                      </td>
                    </tr>
                  </table>
                </div>
              )}
              <br />
              {other === "normal" && (
                <div style={{ padding: "0px 20px" }}>
                  <table width="100%" style={{ fontSize: "14px" }}>
                    <tr
                      style={{
                        backgroundColor: "#fff",
                        height: "50px",
                      }}
                    >
                      <td
                        style={{
                          borderRight: "0px solid #aaa",
                          padding: "0px 10px",
                          background: "#E76464",
                          color: "#fff",
                        }}
                      >
                        {"ยอดเงินส่วนลดทั้งหมด/"}
                        <br />
                        {"Total discount amount"}
                      </td>
                      <td
                        align="right"
                        style={{
                          borderLeft: "0px solid #aaa",
                          padding: "0px 10px",
                          color: "#fff",
                          background: "#E76464",
                        }}
                      >
                        <b>{numberWithCommas(sumDiscount, 2)}</b>
                      </td>
                    </tr>
                  </table>
                </div>
              )}
              <div style={{ padding: "0px 20px" }}>
                <table width="100%" style={{ fontSize: "14px" }}>
                  <tr
                    style={{
                      backgroundColor: "#fff",
                      height: "50px",
                    }}
                  >
                    <td
                      style={{
                        borderRight: "0px solid #aaa",
                        padding: "0px 10px",
                        background: "#fff",
                        color: "#000",
                      }}
                    >
                      {"ยอดเงินหลังหักส่วนลดทั้งหมด /"}
                      <br />
                      {"Balance after all discounts."}
                    </td>
                    <td
                      align="right"
                      style={{
                        borderLeft: "0px solid #aaa",
                        padding: "0px 10px",
                        color: "#000",
                        background: "#fff",
                      }}
                    >
                      <b>{numberWithCommas(sum, 2)}</b>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              title={"ยกเลิก"}
              background="#FF6760"
              onClick={() => history.push(`/opd/so/${id}`)}
            />

            <MainButton
              className="mg-10"
              title="ยืนยันรายการ/Confirm Item"
              onClick={() => {
                setIsOpen(true);
                getUserAgencySo();
                formCo_User.setFieldsValue({
                  agencySo: "",
                  hearAboutDermasters: "",
                  checkDer: "",
                  otherDer: "",
                });
              }}
            />
          </div>
        </div>
      </Form>
    </div>
  );
};
export default Conclusion;
